/// Checks user clicks and key presses
/// If user clicks and its 30 seconds from last keep alive call
/// it will call keep alive

import { useAuthentication } from "./authentication/composables/use-authentication";
import { useNgSession } from "./ng-session";

export const useKeepAlive = () => {
    const { isLoggedIn } = useNgSession();
    let lastKeepAlive = Date.now();

    const handler = async () => {
        if (!isLoggedIn.value) {
            return;
        }

        if (Date.now() - lastKeepAlive < 30_000) return;
        await useAuthentication().keepSessionAlive();
        lastKeepAlive = Date.now();
    };

    document.addEventListener("click", handler, { passive: true });
    document.addEventListener("keypress", handler, { passive: true });
};
